import { Outlet } from 'react-router-dom';
import { SearchInPageProvider } from '../../context/searchText';

function SnapshotsPage() {
  return (
    <SearchInPageProvider>
      <Outlet />
    </SearchInPageProvider>
    
  )
}

export default SnapshotsPage;